import { AuthUser }   from "../models/AuthUser";
import UserStorage    from "../storages/UserStorage";
import authRestClient from "./clients/AuthRestClient";

/** Using given email and refresh-token to request a new JWT object from the guest AUTH service provider. */
export async function refreshToken(token: string, refreshToken: string): Promise<AuthUser | null> {

    await authRestClient.post<AuthUser>("/auth/guest/refresh-token", { Token: token, RefreshToken: refreshToken })
        .then(response => {
            /* Check if response code is "200".
             * Store authenticated user in storage
             */
            if (response.status === 200)
            {
                UserStorage.setUser(response.data);
                return response.data;
            }
        })
        .catch(error => {
            /* Handel catched error */
            console.error(error);
            return null;
        })

    return null;
}

/** Logs of fthe current user. Renders the current token invalid. */
export function logout() {
    UserStorage.destroy();
}